import { PageComponent } from '../../../../uiComponent/PageComponent/PageComponent';
import { BillableTimeReviewTableContainer } from '../../container/BillableTimeReviewTableContainer/BillableTimeReviewTableContainer';

export const BillableTimeReviewPageComponent = () => (
  <PageComponent title="Billable Time Requiring Review">
    <BillableTimeReviewTableContainer />
  </PageComponent>
);
